export enum MeasurementSystem {
  imperial = 'imperial',
  metric = 'metric',
}
